$(document).ready(function () {
    let tabla = $(".table-quotes-by-book tbody");
    $(".item-quote").removeClass('input-textarea-intermitente')
    $("#table-books tbody").on('click', '.add-qoutes-book', function (e) {
        clearForm()
        $(".item-slug").val($(this).data('slug'))
        $(".item-action").val("create")
        $("#text-modal-quotes").text('Ingresar recomendación')
        $("#modal-quotes").modal('show')
        getQuotesForBooks($(this).data('slug'))
    })

    $("#form-quotes").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        sendData(data, '/admin/books/send-quote', 'modal-quotes')
    })

    $(document).on('click', '.edit-quote', function (e) {
        e.preventDefault()
        let index = $(this).data('index')
        let data = $(this).data('data')
        $(".item-action").val("Edit")
        $.each(data, function (index, value) {
            if (index == "id") {
                $(".item-quote_id").val(value)
            }
            $(".item-" + index).val(value)
        })
        scrollAlInicio()
    })

    $(document).on('click', '.clearInputs', function (e) {
        e.preventDefault()
        clearForm()
    })

    $(document).on('click', '.delete-quote', function (e) {
        e.preventDefault()
        let data = new FormData()
        data.append('id',$(this).data('identificador'))
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                sendData(data,'/admin/books/delete-quote','modal-quotes')
            }
        })

    })

    function getQuotesForBooks(slug) {
        $.ajax({
            url: "/admin/get-quote-by-slug/" + slug, type: "get", processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                document.getElementById('div_recommendations_books').innerHTML = response;
            }
        })
    }

    function sendData(data, route, modal) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                clearForm()
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    document.getElementById('div_recommendations_books').innerHTML = response;
                }, 1000)
                alertSuccess('Registros actualizados')
            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function clearForm() {
        $(".item-quote").val('')
        $(".item-author").val('')
        $(".item-quote_id").val('')
        $(".item-action").val("create")
    }

    function scrollAlInicio() {
        $(".item-quote").addClass('input-textarea-intermitente')
        $(".item-author").addClass('input-textarea-intermitente')
        setTimeout(function () {
            $(".item-quote").removeClass('input-textarea-intermitente')
            $(".item-author").removeClass('input-textarea-intermitente')
        }, 4000)
        let myModal = document.getElementById("modal-quotes");
        myModal.scrollTop = 0;
    }

})
